/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiAlbumsIdTracksOrderMutationRequest, PutApiAlbumsIdTracksOrderMutationResponse, PutApiAlbumsIdTracksOrderPathParams, PutApiAlbumsIdTracksOrder400, PutApiAlbumsIdTracksOrder401, PutApiAlbumsIdTracksOrder403, PutApiAlbumsIdTracksOrder404, PutApiAlbumsIdTracksOrder500 } from "../../types/PutApiAlbumsIdTracksOrder.ts";
import { putApiAlbumsIdTracksOrderMutationResponseSchema, putApiAlbumsIdTracksOrderMutationRequestSchema } from "../../zod/AlbumSchemas/putApiAlbumsIdTracksOrderSchema.ts";

function getPutApiAlbumsIdTracksOrderUrl({ id }: { id: PutApiAlbumsIdTracksOrderPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/albums/${id}/tracks/order` as const }  
  return res
}

/**
 * @summary Метод изменения порядка треков в альбоме.
 * {@link /api/albums/:Id/tracks/order}
 */
export async function putApiAlbumsIdTracksOrder({ id, data }: { id: PutApiAlbumsIdTracksOrderPathParams["Id"]; data?: PutApiAlbumsIdTracksOrderMutationRequest }, config: Partial<RequestConfig<PutApiAlbumsIdTracksOrderMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiAlbumsIdTracksOrderMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiAlbumsIdTracksOrderMutationResponse, ResponseErrorConfig<PutApiAlbumsIdTracksOrder400 | PutApiAlbumsIdTracksOrder401 | PutApiAlbumsIdTracksOrder403 | PutApiAlbumsIdTracksOrder404 | PutApiAlbumsIdTracksOrder500>, PutApiAlbumsIdTracksOrderMutationRequest>({ method : "PUT", url : getPutApiAlbumsIdTracksOrderUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiAlbumsIdTracksOrderMutationResponseSchema.parse(res.data)
}